import { PermissionEnum } from '../../user-roles/types';

export const onChangeHelperSingle = (
  key: PermissionEnum,
  value: boolean,
  columnsDataItem: any,
  columnsData: Partial<Record<string, {
      title: string;
      pagesKeys: PermissionEnum[] | [];
      pages?: Partial<Record<string, {
          title: string;
          sectionKey: PermissionEnum;
          actionsKeys: PermissionEnum[] | [];
          actions?: Partial<Record<string, {
              title: string;
              description: string;
              sectionKey: PermissionEnum;
              pageKey: PermissionEnum;
            }>>;
        }>>;
    }>>,
  setValues: React.Dispatch<React.SetStateAction<PermissionEnum[]>>,
  activeActions?: PermissionEnum[],
  activePages?: PermissionEnum[],
): void => {
  const pages = columnsData[key]?.pages;
  const pagesKeys = columnsData[key]?.pagesKeys || [];
  const actionsKeys =
    pages &&
    Object.values(pages)
      ?.map(
        (item) =>
          item?.actions && [
            ...(Object.keys(item?.actions) as PermissionEnum[]),
          ],
      )
      .flat();

  if (value) {
    if (columnsDataItem.pageKey) {
      setValues((prev) => [
        key,
        ...prev.filter(
          (el) =>
            el !== columnsDataItem.sectionKey && el !== columnsDataItem.pageKey,
        ),
        columnsDataItem.sectionKey,
        columnsDataItem.pageKey,
      ]);
    } else if (columnsDataItem.sectionKey) {
      setValues((prev) => [
        key,
        ...prev.filter((el) => el !== columnsDataItem.sectionKey),
        columnsDataItem.sectionKey,
      ]);
    } else {
      setValues((prev) => [
        key,
        ...pagesKeys,
        ...prev.filter((el) =>
          actionsKeys?.length ? !actionsKeys.includes(el) : el,
        ),
      ]);
    }
  } else if (columnsDataItem.pageKey) {
    //  тыкаем action
    //  отключаем экшен, если все экшены выключены (выключаем последний) - выкл страницу - если все страницы выключены - выкл секцию

    const activedPages = columnsData[
      columnsDataItem.sectionKey
    ]?.pagesKeys.filter((el) => activePages?.includes(el));

    const activedActions = columnsData[columnsDataItem.sectionKey]?.pages![
      columnsDataItem.pageKey
    ]?.actionsKeys.filter((el) => activeActions?.includes(el));

    setValues((prev) => [
      ...prev.filter((item) => {
        if (activedActions?.length === 1 && activedActions[0] === key) {
          if (activedPages?.length === 1) {
            return (
              item !== key &&
              item !== columnsDataItem.pageKey &&
              item !== columnsDataItem.sectionKey
            );
          }
          return item !== key && item !== columnsDataItem.pageKey;
        }
        return item !== key;
      }),
    ]);
  } else if (columnsDataItem.sectionKey) {
    //  тыкаем page
    //  отключаем страницу - экшены, если все страницы выключены (выключаем последнюю) - выкл секцию
    const activedPages = columnsData[
      columnsDataItem.sectionKey
    ]?.pagesKeys.filter((el) => activePages?.includes(el));

    setValues((prev) =>
      prev.filter((item) => {
        if (activedPages?.length === 1 && activedPages[0] === key) {
          return (
            item !== key &&
            !columnsDataItem.actionsKeys.includes(item) &&
            item !== columnsDataItem.sectionKey
          );
        }
        return item !== key && !columnsDataItem.actionsKeys.includes(item);
      }),
    );
  } else {
    //  тыкаем section
    //  отключаем секцию - страницы - экшены

    setValues((prev) =>
      prev.filter(
        (item) =>
          item !== key &&
          !columnsDataItem.pagesKeys?.includes(item) &&
          !actionsKeys?.includes(item),
      ),
    );
  }
};

export const onChangeHelperArray = (
  keys: PermissionEnum[],
  value: boolean,
  columnsDataItem: any,
  columnsData: Partial<Record<string, {
      title: string;
      pagesKeys: PermissionEnum[] | [];
      pages?: Partial<Record<string, {
          title: string;
          sectionKey: PermissionEnum;
          actionsKeys: PermissionEnum[] | [];
          actions?: Partial<Record<string, {
              title: string;
              description: string;
              sectionKey: PermissionEnum;
              pageKey: PermissionEnum;
            }>>;
        }>>;
    }>>,
  setValues: React.Dispatch<React.SetStateAction<PermissionEnum[]>>,
  activePages?: PermissionEnum[],
  pageId?: string,
): void => {
  if (value) {
    setValues((prev) => {
      if (columnsDataItem.sectionKey && columnsDataItem.pageKey) {
        const section = columnsData[
          columnsDataItem.sectionKey
        ]!.pagesKeys.filter((item) => item === pageId);

        const array =
          pageId !== 'all'
            ? section
            : columnsData[columnsDataItem.sectionKey]!.pagesKeys;

        return [
          ...prev,
          ...keys.filter((item) => !prev.includes(item)),
          columnsDataItem.sectionKey,
          ...array,
        ];
      }
      if (columnsDataItem.sectionKey) {
        return [
          ...prev,
          ...keys.filter((item) => !prev.includes(item)),
          columnsDataItem.sectionKey,
        ];
      }

      return [...prev, ...keys.filter((item) => !prev.includes(item))];
    });
  } else {
    setValues((prev) => {
      if (columnsDataItem.sectionKey && columnsDataItem.pageKey) {
        const activedPages = columnsData[
          columnsDataItem.sectionKey
        ]?.pagesKeys.filter((el) => activePages?.includes(el));

        if (
          activedPages?.length === 1 &&
          activedPages[0] === columnsDataItem.pageKey
        ) {
          return prev.filter((item) => !keys.includes(item));
        }

        let filtered;

        if (pageId === 'all' && activedPages?.length) {
          filtered = prev.filter((item) => !keys.includes(item));
        } else {
          filtered = prev.filter((item) => !keys.includes(item));
        }

        return filtered;
      }

      if (columnsDataItem.sectionKey) {
        const sectionActionKeys: string[] = [];

        if (activePages) {
          activePages?.forEach((item) => {
            if (
              columnsData[columnsDataItem.sectionKey]?.pages &&
              // @ts-ignore
              columnsData[columnsDataItem.sectionKey]?.pages[item]
            ) {
              sectionActionKeys.push(
                // @ts-ignore
                // eslint-disable-next-line no-unsafe-optional-chaining
                ...columnsData[columnsDataItem.sectionKey]?.pages[item]
                  ?.actionsKeys,
              );
            }
          });
        }

        return prev.filter(
          (item) =>
            !keys.includes(item) &&
            item !== columnsDataItem.sectionKey &&
            sectionActionKeys.every((key) => item !== key),
        );
      }

      return [...prev, ...keys.filter((item) => !prev.includes(item))];
    });
  }
};
